import { translate } from '../../utils/translation'

export const useTranslation = () => ({
  notIdentified: translate('Não identificado'),
  credit: translate('Crédito'),
  debit: translate('Débito'),
  cash: translate('Cash'),
  points: translate('Pontos'),
  pending: translate('Pendente'),
  confirmed: translate('Confirmado'),
  canceled: translate('Cancelado'),
})
